import { BoxShadowsType } from '@mui/material'

export const BoxShadows: BoxShadowsType = {
  teaser: '0px 2px 44px -20px rgba(0, 0, 0, 0.5)',
  header: '0px 0px 10px 0px rgba(75, 75, 75, 0.18)',
  stage: '0px 0px 10px 0px rgba(0, 0, 0, 0.35)',
}
